import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AccessibilityProvider } from './contexts/AccessibilityContext';
import { RecaptchaProvider } from './contexts/RecaptchaContext';
import { Toaster } from './components/ui/sonner';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { AdminBanner } from './components/AdminBanner';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';
import GoogleAnalytics from './components/GoogleAnalytics';
import Home from './pages/Home';
import About from './pages/About';
import Listings from './pages/Listings';
import Qualifications from './pages/Qualifications';
import PropertyDetail from './pages/PropertyDetail';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import Login from './pages/Login';
import NotFound from './pages/NotFound';

function App() {
  return (
    <AccessibilityProvider>
      <ThemeProvider>
        <RecaptchaProvider>
          <div className="App">
          <BrowserRouter>
            <GoogleAnalytics />
            <ScrollToTop />
            <AdminBanner />
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/listings" element={<Listings />} />
              <Route path="/property/:slug" element={<PropertyDetail />} />
              <Route path="/qualifications" element={<Qualifications />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              } />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
          </BrowserRouter>
          <Toaster />
          </div>
        </RecaptchaProvider>
      </ThemeProvider>
    </AccessibilityProvider>
  );
}

export default App;